var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import './style.css';
var ReactModal = function (props) {
    var title = props.title, height = props.height, width = props.width, isVisible = props.isVisible, setVisible = props.setVisible;
    return (_jsx(Modal, __assign({ ariaHideApp: false, headerTitle: title, open: isVisible, onClose: function () {
            setVisible(false);
        }, isOpen: isVisible, onRequestClose: function () {
            setVisible(false);
        }, style: {
            content: {
                height: "".concat(height),
                width: "".concat(width),
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: '2px 2px 16px rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '0',
                border: '0',
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
            },
        }, contentLabel: title }, { children: props.children })));
};
export default ReactModal;
